module.exports = __webpack_public_path__ + "static/media/gaming.7bdd6b34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/gaming.jpg
// module id = 563
// module chunks = 6